import React from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  journalItemsLinesTable,
  journalLinesTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getJournalTransactionLineItems } from "../../../api/journal";

export default function LinesTable() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [subtabIndex, setSubtabIndex] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [itemsSum, setitemsSum] = useState("0.00");
  const [account, setAccount] = useState("");
  const pageDetail = slugMap[params.slug];
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  async function getTransactionItemsData(limit, offset) {
    try {
      const { data } = await getJournalTransactionLineItems(user.token, {
        id: params.docNo,
        limit,
        offset,
        account: account,
      });
      setRowData(data?.data?.accountlist);
      setitemsSum(data.data.itemsum);
      return {
        rows: data.data.items,
        total: data.data.itemstotal,
        error: false,
      };
    } catch (error) {
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
  }
  const handleChange = async (event) => {
    setAccount(event);
    refreshTable();
  };
  const handleResetChange = async () => {
    refreshTable();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    setAccount("")("");
  };
  return (
    <>
      <Tabs
        value={subtabIndex}
        // onChange={handleChange}
        onChange={(e, nv) => {
          setSubtabIndex(nv);
        }}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className="tabs-bkg1"
      >
        <Tab label={`${itemsSum} `} />
      </Tabs>
      <Grid container>
      <Grid item xs={12} sm={3} style={{ margin: 5 }}>
       
       
          <FormControl size="small" fullWidth>
            <InputLabel id="demo-simple-select-label">ACCOUNT</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-simple-select"
              value={account}
              label="Account"
              onChange={(event) => handleChange(event.target.value)}
              MenuProps={{
                sx: {
                  minWidth: 200,
                },
                PaperProps: {
                  className: "ve-select",
                  style: {
                    maxHeight: 250,
                    width: 220,
                    overflowY: "auto",
                    display: "block",
                  },
                },
              }}
            >
              <MenuItem className="ve-select-menuItem" disabled>
                Select Account
              </MenuItem>
              {rowData?.map((e, i) => (
                <MenuItem
                  className="ve-select-menuItem"
                  key={i}
                  value={e.account}
                  style={{ whiteSpace: "normal", display: "block" }} // Force vertical list
                >
                  {e.account}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
      </Grid>
      {account && (
            <Grid item xs={12} sm={3} style={{ margin: 5 }}>
            <div style={{ marginBottom: "2px" }}>
              <Button
                type="button"
                style={{ color: "black", margin: "8px" }}
                onClick={(e) =>handleResetChange(e)}
              >
                Reset
              </Button>
            </div>
            </Grid>
          )}
          </Grid>
      <TabPanel value={subtabIndex} index={0}>
        {/* {tabIndexP === 13 ? */}

        <AgGridPaginatedTable
          getTableRows={getTransactionItemsData}
          columns={journalItemsLinesTable}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
        {/* : <></>
            } */}
      </TabPanel>
    </>
  );
}

